import React from "react";
import { Typography } from '@material-ui/core';

import './index.scss';

export default function TypographyComponent(props){
    const { variant, children, component, className } = props;

    return  (
        <Typography
            className={className}
            component={component}
            variant={variant}
        >
            {children}
        </Typography>
    )

}